var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"height":_vm.height,"loading":_vm.loading}},[_c('vue-apex-charts',{staticClass:"mt-2",attrs:{"width":"100%","height":_vm.height,"type":"donut","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }